//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        value: {
            type: Object,
            required: true
        }
    },

    data () {
        return {
            form: this.value,
            activeReasons: [],
            reasonStateDepartment: '',
            reasonStateCollege: '',
            reasonStateAdministration: '',
            reasonTextMedia: '',
            reasonTextTeacher: '',
            reasonTextOther: '',
            reasons: [
                { text: this.$lang.get('register.reason.department_of_education'), additional: 'statesDepartment' },
                { text: this.$lang.get('register.reason.college_of_education'), additional: 'statesCollege' },
                { text: this.$lang.get('register.reason.media'), additional: 'reasonTextMedia' },
                { text: this.$lang.get('register.reason.social_media') },
                { text: this.$lang.get('register.reason.teachers'), additional: 'reasonTextTeacher' },
                { text: this.$lang.get('register.reason.administration'), additional: 'statesAdministration' },
                { text: this.$lang.get('register.reason.other'), additional: 'reasonTextOther' },
                { text: this.$lang.get('register.reason.parents') }
            ],
            states: [
                this.$lang.get('register.states.options.burgenland'),
                this.$lang.get('register.states.options.carinthia'),
                this.$lang.get('register.states.options.lowerAustria'),
                this.$lang.get('register.states.options.upperAustria'),
                this.$lang.get('register.states.options.salzburg'),
                this.$lang.get('register.states.options.styria'),
                this.$lang.get('register.states.options.tyrol'),
                this.$lang.get('register.states.options.vorarlberg'),
                this.$lang.get('register.states.options.vienna')
            ]
        };
    },

    watch: {
        form () {
            this.$emit('input', this.form);
        },
        value () {
            this.dialogVisible = this.value;
        }
    }
};
